var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-backtop',{attrs:{"target":".page-component__scroll .el-scrollbar__wrap","bottom":100}},[_c('div',{staticStyle:{"{\n      height":"100%","width":"100%","background-color":"#f2f5f6","box-shadow":"0 0 6px rgba(0,0,0, .12)","text-align":"center","line-height":"40px","color":"#1989fa"}},[_vm._v(" UP ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }